import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import axios from 'axios';
import { useStore } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import CounterCard from '../../../../components/CounterCard';

const useStyles = makeStyles({
  PICKUP_REQUEST: { backgroundColor: '#2196f3', color: '#fff' },
});

export default function RiderPickupRequest() {
  const store: any = useStore();
  const classes = useStyles();

  const [pickupRequestCount, setPickupRequestCount] = useState(0);

  function fetchPickupRequestCount() {
    axios
      .get(`${process.env.REACT_APP_API_SERVER}/pickup-requests/count`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
        params: {
          status: 'RIDER_ASSIGNED',
        },
      })
      .then((res) => {
        setPickupRequestCount(res.data ?? 0);
      });
  }

  useEffect(() => {
    fetchPickupRequestCount();
    const interval = setInterval(fetchPickupRequestCount, 60000);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Grid item xs={12} sm={4} md={2}>
      <CounterCard
        link="/dashboard/pickup-request?status=RIDER_ASSIGNED"
        shakeIt={pickupRequestCount > 0}
        label="Pickup Requests"
        count={pickupRequestCount}
        cardClassName={classes.PICKUP_REQUEST}
      />
    </Grid>
  );
}
